import React from 'react';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function SubSection({
  title,
  icon,
  children,
}: {
  icon: IconProp;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex items-center gap-1.5 text-base800">
        <FontAwesomeIcon icon={icon} fontSize="24px" className="text-base-s sm:text-base-m" />
        <h4 className="font-title text-title-xs font-medium sm:text-title-s">{title}</h4>
      </div>
      <p className="font-base text-base-m text-base800 sm:text-base-l">{children}</p>
    </div>
  );
}
